<template>
  <div class="screen-height-container">
    <v-card id="facilityNewsletter" class="h-100 d-flex flex-column">
      <v-card-title class="pb-0">
        <h2>Weekly Status Report</h2>
        <v-spacer />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="showSendEmail = true" v-on="on"
              ><v-icon>email</v-icon></v-btn
            >
          </template>
          <span>Deliver report via email</span>
        </v-tooltip>
        <v-btn icon @click="onClose"><v-icon>close</v-icon></v-btn>
      </v-card-title>

      <v-card-text class="pt-0 d-flex flex-column flex-grow-auto">
        <v-row no-gutters class="justify-center">
          <v-col cols="5" sm="3" md="2" lg="2">
            <div style="max-width:135px; margin: auto">
            <vuetify-datepicker
              label="Week Ending"
              v-model="startDate"
              :auto-close="true"
              :min="dateMin"
              :max="dateMax"
            />
            </div>
          </v-col>
        </v-row>

        <div
          class="flex-grow-auto w-100 h-100 d-flex align-center justify-center"
        >
          <v-progress-circular
            v-show="isLoading"
            indeterminate
            color="primary"
          />
          <iframe
            v-show="!isLoading"
            class="h-100 w-100 overflow-auto"
            style="border: none"
            ref="iframe"
          />
        </div>
      </v-card-text>
    </v-card>
    <v-dialog v-model="showSendEmail" persistent max-width="600">
      <v-card>
        <v-card-title>
          <h2>Send Report as Email</h2>
          <v-spacer />
          <v-btn icon @click="showSendEmail = false"
            ><v-icon>close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field
              label="Recipient Emails (comma-delimited)"
              v-model="emails"
              :rules="[rules.requiredNoBlanks]"
            />
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            :disabled="emails === ''"
            text
            @click="sendNewsletter"
            color="primary"
            :loading="sendingEmail"
          >
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Validation from "@/mixins/Validation";
import Trimaster from "@/plugins/servers/trimaster.js";
import moment from "moment";
import vuetifyToast from "@/vuetifyToast.js";
import { mapGetters, mapActions } from "vuex";
import VuetifyDatepicker from "@/components/util/VuetifyDatepicker";

export default {
  name: "facilityNewsletter",
  components: { VuetifyDatepicker },
  mixins: [Validation],

  props: {
    facilityId: {
      type: Number,
      required: true,
    },
    showFakeNewsletter : {
      type: Boolean,
      required: false,
    }
  },

  data() {
    return {
      isLoading: false,
      emails: "",
      sendingEmail: false,
      showSendEmail: false,
      startDate: moment().format("YYYY-MM-DD"),
      metrcLicense: null,
      dateMin: null,
      dateMax: moment().format("YYYY-MM-DD"),
    };
  },

  computed: {
    ...mapGetters(["getUser", "currentFacility"]),
  },

  mounted() {
    this.dateMin = moment(this.dateMax)
      .subtract(7, "days")
      .format("YYYY-MM-DD");
    this.isLoading = true;
    if (localStorage.getItem("metrcLicense")) {
      this.metrcLicense = localStorage.getItem("metrcLicense");
    }
    this.refresh();
  },
  watch: {
    startDate(newVal, oldVal) {
      this.refresh();
    },
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    refresh() {
      let me = this;
      me.isLoading = true;
      Trimaster.get(
        "weeklyReport/getOwnerDashboardReportHtml",
        this.getUser.apitoken,
        {
          facilityId: this.showFakeNewsletter ? 0 : this.facilityId,
          metrcLicenseId: this.metrcLicense,
          date: moment(this.startDate).utc().format('YYYY-MM-DD')
        }
      ).then(([res, err]) => {
        me.isLoading = false;
        const iframe = me.$refs.iframe;
        let doc = iframe.contentDocument
          ? iframe.contentDocument
          : iframe.contentWindow.document;
        doc.write(res);
      });
    },
    sendNewsletter() {
      let me = this;
      this.sendingEmail = true;
      Trimaster.get(
        "weeklyReport/ownerDashboardReport",
        this.getUser.apitoken,
        {
          facilityId: this.showFakeNewsletter ? 0 : this.facilityId,
          metrcLicenseId: this.metrcLicense,
          emails: this.emails.split(",").map((email) => email.trim()),
          date: this.startDate,
        }
      ).then(([res, err]) => {
        me.sendingEmail = false;
        me.showSendEmail = false;
        me.emails = "";
        if (!err) {
          vuetifyToast.success("Email Sent");
          me.$emit("close");
        } else {
          vuetifyToast.error("An error occurred. Please try again later.");
        }
      });
    },
  },
};
</script>

